<template>
	<v-data-table
		:items="items"
		:headers="headers"
		:footer-props="footer_props"
		:options.sync="options"
		class="vdatable mt-1"
		dense
		fixed-header
		:loading="loading"
		:value="selected_row"
		:server-items-length="total_record"
		:item-key="item_key == null ? `id` : item_key"
		v-model="vModel"
		:class="`${$CoreSettingsJs.isMobile() ? 'vdataMobile' : ''} ${$CoreSettingsJs.emptyObjectValidation(tableClass) ? '' : tableClass}`"
		:height="height"
		:single-select="multiSelect ? false : true"
		:show-select="disabled_select ? false : true"
		:hide-default-footer="hideFooter"
		:hide-default-header="hideHeader"
		:item-selectable="isSelectable"
		@click:row="singleRowSelect"
		@dblclick:row="handleDoubleClick"
	>
		<template #header="{ props: { headers } }" v-if="['pn_order'].includes(module_name) && !$CoreSettingsJs.emptyObjectValidation(items)">
			<slot name="custom_header" v-bind="headers"></slot>
		</template>
		<template v-slot:item="{ item, index }" v-if="['delivery_agent', 'pn_payment', 'pn_order', 'soRcvList', 'del_add'].includes(module_name) && !$CoreSettingsJs.emptyObjectValidation(items)">
			<slot name="row_item" v-bind="{ item, index }"></slot>
		</template>

		<template v-for="(slot, name) in $scopedSlots" v-slot:[name]="header">
			<slot :name="header" v-bind="header"></slot>
		</template>

		<template v-for="(slot, name) in $scopedSlots" v-slot:[name]="item">
			<slot :name="name" v-bind="item"></slot>
			<slot :name="item" v-bind="item"></slot>
		</template>

		<template v-if="show_tbl_foot" v-slot:foot>
			<slot name="custom_foot"></slot>
		</template>

		<template v-slot:[`item.status`]="{ item }">
			<b-badge class="text-center" :variant="$CoreSettingsJs.handleBadgeVariant(item.status)" size="sm">
				<span v-text="$Common.getStatusName(item.status)"></span>
			</b-badge>
		</template>
		<template v-slot:[`item.do_created`]="{ item }">
			<b-badge class="text-center" :variant="$CoreSettingsJs.handleBadgeVariant(item.do_created)" size="sm">
				<span v-text="$CoreSettingsJs.handleYesNo(item.do_created)"></span>
			</b-badge>
		</template>
		<!-- <template v-slot:[`item.loading_status`]="{ item }">
			<b-badge class="text-center" :variant="$CoreSettingsJs.handleBadgeVariant(item.loading_status)" size="sm">
				<span v-text="$Common.getIsOpenDesc(item.loading_status)"></span>
			</b-badge>
		</template>-->
		-->
		<template v-slot:[`item.display_loading_status`]="{ item }">
			<b-badge class="text-center" :variant="$CoreSettingsJs.handleBadgeVariant(item.display_loading_status)" size="sm">
				<span v-text="$Common.getIsOpenDesc(item.display_loading_status)"></span>
			</b-badge>
		</template>
		<template v-slot:[`item.cl_loading_status`]="{ item }">
			<b-badge class="text-center" :variant="$CoreSettingsJs.handleBadgeVariant(item.cl_loading_status == 0 ? 1 : 0)" size="sm">
				<span v-text="$Common.getIsOpenDesc(item.cl_loading_status == 0 ? 1 : 0)"></span>
			</b-badge>
		</template>
		<template v-slot:[`item.agent`]="{ item }">
			<span v-if="module_name !== 'maintain_agent'" v-text="item.agent"></span>
			<b-badge v-if="module_name == 'maintain_agent'" class="text-center" :variant="$CoreSettingsJs.handleBadgeVariant(item.agent)" size="sm">
				<span v-text="$CoreSettingsJs.handleYesNo(item.agent)"></span>
			</b-badge>
		</template>
		<template v-slot:[`item.checker`]="{ item }">
			<b-badge class="text-center" :variant="$CoreSettingsJs.handleBadgeVariant(item.checker)" size="sm">
				<span v-text="$CoreSettingsJs.handleYesNo(item.checker)"></span>
			</b-badge>
		</template>
		<template v-slot:[`item.status_user`]="{ item }">
			<b-badge class="text-center" :variant="$CoreSettingsJs.handleBadgeVariant(item.status)" size="sm">
				<span v-text="$Common.getStatusName(item.status)"></span>
			</b-badge>
		</template>
		<template v-if="!['manifestConsignment'].includes(module_name)" v-slot:[`item.is_sensitive`]="{ item }">
			<b-badge class="text-center" :variant="$CoreSettingsJs.handleBadgeVariant(item.is_sensitive)" size="sm">
				<span v-text="$CoreSettingsJs.handleYesNo(item.is_sensitive)"></span>
			</b-badge>
		</template>
		<template v-slot:[`item.received_amount`]="{ item }">
			<span v-text="$CoreSettingsJs.onFormatterNo(item.received_amount)"></span>
		</template>
		<template v-if="!['soRcvList', 'order-receiving'].includes(module_name)" v-slot:[`item.cash_payment`]="{ item }">
			<span v-text="$CoreSettingsJs.onFormatterNo(item.cash_payment)"></span>
		</template>
		<template v-if="!['soRcvList', 'order-receiving'].includes(module_name)" v-slot:[`item.my_paid`]="{ item }">
			<span v-text="$CoreSettingsJs.onFormatterNo(item.my_paid)"></span>
		</template>
		<template v-if="!['soRcvList', 'order-receiving'].includes(module_name)" v-slot:[`item.balance_amount`]="{ item }">
			<span v-text="$CoreSettingsJs.onFormatterNo(item.balance_amount)"></span>
		</template>
		<template v-if="module_name != 'soRcvList'" v-slot:[`item.deposit_amount`]="{ item }">
			<span v-text="$CoreSettingsJs.onFormatterNo(item.deposit_amount)"></span>
		</template>
		<template v-if="!['order-receiving'].includes(module_name)" v-slot:[`item.ttl_kg`]="{ item }">
			<span v-text="$CoreSettingsJs.onFormatterNo(item.ttl_kg, 2)"></span>
		</template>
		<template v-if="!['order-receiving'].includes(module_name)" v-slot:[`item.ttl_m3`]="{ item }">
			<span v-text="$CoreSettingsJs.onFormatterNo(item.ttl_m3, 3)"></span>
		</template>
		<template v-if="!['order-receiving'].includes(module_name)" v-slot:[`item.ttl_ctn`]="{ item }">
			<span v-text="$CoreSettingsJs.onFormatterNo(item.ttl_ctn, 0)"></span>
		</template>
		<template v-if="!['order-receiving'].includes(module_name)" v-slot:[`item.kg`]="{ item }">
			<span v-text="$CoreSettingsJs.onFormatterNo(item.kg, 2)"></span>
		</template>
		<template v-if="!['order-receiving'].includes(module_name)" v-slot:[`item.m3`]="{ item }">
			<span v-text="$CoreSettingsJs.onFormatterNo(item.m3, 3)"></span>
		</template>
		<template v-if="!['order-receiving'].includes(module_name)" v-slot:[`item.ctn`]="{ item }">
			<span v-text="$CoreSettingsJs.onFormatterNo(item.ctn, 0)"></span>
		</template>
		<template v-slot:[`item.total_quantity`]="{ item }">
			<span v-text="$CoreSettingsJs.onFormatterNo(item.total_quantity)"></span>
		</template>
		<template v-slot:[`item.total_amount`]="{ item }">
			<span v-text="$CoreSettingsJs.onFormatterNo(item.total_amount)"></span>
		</template>
		<template v-if="module_name != 'Consignment S/O'" v-slot:[`item.status`]="{ item }">
			<b-badge class="text-center" :variant="$CoreSettingsJs.handleBadgeVariant(item.status, module_name)" size="sm">
				<span v-text="$CoreSettingsJs.handleStatusDesc(item.status, module_name)"></span>
			</b-badge>
		</template>
		<template v-slot:[`item.favourite`]="{ item }">
			<b-badge class="text-center" :variant="$CoreSettingsJs.handleBadgeVariant(item.favourite)" size="sm">
				<span v-text="$CoreSettingsJs.handleYesNo(item.favourite)"></span>
			</b-badge>
		</template>
		<template v-slot:[`item.checker`]="{ item }">
			<b-badge class="text-center" :variant="$CoreSettingsJs.handleBadgeVariant(item.checker)" size="sm">
				<span v-text="$CoreSettingsJs.handleYesNo(item.checker)"></span>
			</b-badge>
		</template>
		<template v-slot:[`item.marking_status`]="{ item }">
			<b-badge v-if="item.marking_status != null" class="text-center" :variant="markingStatusBadge(item.marking_status)" size="sm">
				<span v-text="markingStatusName(item.marking_status)"></span>
			</b-badge>
		</template>
		<template v-if="module_name == `localeSummary`" v-slot:[`item.image`]="{ item }">
			<span class="symbol symbol-20 mr-3">
				<img :src="item.image" alt="" />
			</span>
		</template>
		<template v-if="module_name == `noticeType`" v-slot:[`item.order_receipt`]="{ item }">
			<b-badge class="text-center" :variant="$CoreSettingsJs.handleBadgeVariant(item.order_receipt)" size="sm">
				<span v-text="getOrderReceiptDesc(item.order_receipt)"></span>
			</b-badge>
		</template>
		<template v-if="module_name == `noticeType`" v-slot:[`item.cash_payment`]="{ item }">
			<b-badge class="text-center" :variant="$CoreSettingsJs.handleBadgeVariant(item.cash_payment)" size="sm">
				<span v-text="getCashPaymentDesc(item.cash_payment)"></span>
			</b-badge>
		</template>
		<template v-if="module_name == `categoryType`" v-slot:[`item.use_for_invoice`]="{ item }">
			<b-badge class="text-center" :variant="$CoreSettingsJs.handleBadgeVariant(item.use_for_invoice)" size="sm">
				<span v-text="$CoreSettingsJs.handleYesNo(item.use_for_invoice)"></span>
			</b-badge>
		</template>
		<template v-if="module_name == `uom`" v-slot:[`item.use_epo_inv_receive`]="{ item }">
			<b-badge class="text-center" :variant="$CoreSettingsJs.handleBadgeVariant(item.use_epo_inv_receive)" size="sm">
				<span v-text="$CoreSettingsJs.handleYesNo(item.use_epo_inv_receive)"></span>
			</b-badge>
		</template>
		<template v-if="module_name == `uom`" v-slot:[`item.is_percentage`]="{ item }">
			<b-badge class="text-center" :variant="$CoreSettingsJs.handleBadgeVariant(item.is_percentage)" size="sm">
				<span v-text="$CoreSettingsJs.handleYesNo(item.is_percentage)"></span>
			</b-badge>
		</template>
		<template v-if="module_name == `sensitiveType`" v-slot:[`item.use_for_receiving_epo`]="{ item }">
			<b-badge class="text-center" :variant="$CoreSettingsJs.handleBadgeVariant(item.use_for_receiving_epo)" size="sm">
				<span v-text="$CoreSettingsJs.handleYesNo(item.use_for_receiving_epo)"></span>
			</b-badge>
		</template>
		<template v-if="module_name == `users`" v-slot:[`item.roles`]="{ item }">
			<div class="d-flex">
				<b-badge class="mr-1" variant="secondary" v-for="(r, idx) in JSON.parse(item.roles)" :key="`role${idx}`">
					<span v-text="r"></span>
				</b-badge>
			</div>
		</template>
		<template v-if="module_name == `users`" v-slot:[`item.data_filters`]="{ item }">
			<div class="d-flex">
				<b-badge class="mr-1" variant="secondary" v-for="(d, idx) in JSON.parse(item.data_filters)" :key="`data_filters${idx}`">
					<span v-text="d"></span>
				</b-badge>
			</div>
		</template>
		<template v-if="module_name == `users`" v-slot:[`item.ignore_data_filter`]="{ item }">
			<b-badge class="text-center" :variant="$CoreSettingsJs.handleBadgeVariant(item.ignore_data_filter)" size="sm">
				<span v-text="$CoreSettingsJs.handleYesNo(item.ignore_data_filter)"></span>
			</b-badge>
		</template>
		<template v-if="module_name == `inbound`" v-slot:[`item.ctn`]="{ item }">
			<span v-text="$CoreSettingsJs.onFormatterNo(item.ctn, 0)"></span>
		</template>
		<template v-if="module_name == `inbound`" v-slot:[`item.plt`]="{ item }">
			<span v-text="$CoreSettingsJs.onFormatterNo(item.plt, 0)"></span>
		</template>
		<template v-if="module_name == `ref-id`" v-slot:[`item.total_m3`]="{ item }">
			<span v-text="`${$CoreSettingsJs.onFormatterNo(item.total_m3, 3)}`"></span>
		</template>
		<template v-if="module_name == `ref-id`" v-slot:[`item.total_ctns`]="{ item }">
			<span v-text="`${$CoreSettingsJs.onFormatterNo(item.total_ctns, 0)}`"></span>
		</template>
		<template v-if="module_name == `ref-id`" v-slot:[`item.total_gross_weight`]="{ item }">
			<span v-text="`${$CoreSettingsJs.onFormatterNo(item.total_gross_weight)}`"></span>
		</template>
		<template v-if="module_name == `ref-id`" v-slot:[`item.total_net_weight`]="{ item }">
			<span v-text="`${$CoreSettingsJs.onFormatterNo(item.total_net_weight)}`"></span>
		</template>
		<template v-if="module_name == `ref-id`" v-slot:[`item.total_amt`]="{ item }">
			<span v-text="`${$CoreSettingsJs.onFormatterNo(item.total_amt)}`"></span>
		</template>
	</v-data-table>
</template>

<script>
export default {
	name: "WmsServerMasterDataSummary",
	props: {
		items: null,
		headers: null,
		loading: false,
		total_record: 0,
		selected_row: [],
		module_name: null,
		multiSelect: {
			type: Boolean,
			default: false
		},
		disabled_select: {
			type: Boolean,
			default: false
		},
		item_key: null,
		form_valid_ref_id: [],
		hideFooter: false,
		hideHeader: false,
		tableClass: {
			type: String,
			default: null
		},
		enable_double_click: {
			type: Boolean,
			default: false
		},
		show_tbl_foot: {
			type: Boolean,
			default: false
		},
		isSelectable: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			options: this.$CoreSettingsJs.DATATABLE_OPTIONS(),
			footer_props: this.$CoreSettingsJs.FOOTER_PROPS,
			ref_id_selections: []
		};
	},
	mounted() {
		const itemsPerPage = this.module_name == "gim-world-post-order" ? 500 : 10;
		this.options = this.$CoreSettingsJs.DATATABLE_OPTIONS(itemsPerPage);
	},
	computed: {
		vModel: {
			get() {
				return this.selected_row;
			},
			set(val) {
				this.$emit("rowSelected", val);
			}
		},
		height() {
			const height = this.$Common.dataTableHeightHandle();
			return height;
		}
	},
	watch: {
		options: {
			handler() {
				this.$emit("searchRecord");
			},
			deep: true
		}
	},
	methods: {
		singleRowSelect(row) {
			if (!this.multiSelect) {
				if (this.module_name == "system-log") {
					this.$emit("singleRowSelect", row);
				} else {
					this.$emit("rowSelected", row);
				}
			}
		},
		markingStatusBadge(status) {
			let status_option = this.$CoreJs.markingStatusSelection.find((data) => data.id == status);
			return status_option.color;
		},
		markingStatusName(status) {
			let status_option = this.$CoreJs.markingStatusSelection.find((data) => data.id == status);
			return status_option.name;
		},
		async init_getRefIds() {
			this.ref_id_selections = await this.$CoreJs.refIdSelection({
				loaded: 0,
				set_linkage: 0
			});
		},

		validate_ref_ids(id) {
			if (this.form_valid_ref_id.some((x) => x.id == id)) return this.form_valid_ref_id.find((x) => x.id == id).result;
			return null;
		},
		handleDoubleClick(event, { item, index }) {
			event.preventDefault();
			if (this.enable_double_click) {
				this.$emit("handleDoubleClick", { item, index });
			}
		}
	}
};
</script>
